import Main from '@/layout/main.vue'

const routes = [
    {
        path: '/sync',
        name: 'sync',
        meta: { title: '同步' },
        redirect: '/sync/diamond_supplier',
        component: Main,
        children: [
            {
                path: '/sync/diamond_supplier',
                name: 'sync_diamond_supplier',
                meta: {
                    title: '钻石供应商',
                    icon: 'yiguanzhugongyingshang',
                    parentPath: '/sync',
                    permission: ['view']
                },
                component: () => import('@/views/sync/diamond/supplier.vue')
            },
            {
                path: '/sync/goods_supplier',
                name: 'sync_goods_supplier',
                meta: {
                    title: '珠宝供应商(待)',
                    icon: 'icon_fenxiao_grade',
                    parentPath: '/sync',
                    permission: ['view']
                },
                // component: () => import('@/views/sync/goods/supplier.vue')
            }
            // {
            //     path: '/sync/diamond_tokens',
            //     name: 'sync_diamond_tokens',
            //     meta: {
            //         title: '钻石接口管理',
            //         icon: 'icon_shuju_liuliang',
            //         parentPath: '/sync',
            //         permission: ['view']
            //     },
            //     component: () => import('@/views/sync/tokens/diamond_tokens.vue')
            // },
            // {
            //     path: '/sync/goods_tokens',
            //     name: 'sync_goods_tokens',
            //     meta: {
            //         title: '珠宝接口管理(待)',
            //         icon: 'icon_shuju_liuliang',
            //         parentPath: '/sync',
            //         permission: ['view']
            //     },
            //     // component: () => import('@/views/sync/tokens.vue')
            // }
        ]
    }
]

export default routes
